import script from "./OnboardingTutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingTutorial.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingTutorial.vue?vue&type=style&index=0&id=33e41ec7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e41ec7"]])

export default __exports__